import { render, staticRenderFns } from "./access-denied.view.vue?vue&type=template&id=2d56f062&scoped=true&"
import script from "./access-denied.view.vue?vue&type=script&lang=ts&"
export * from "./access-denied.view.vue?vue&type=script&lang=ts&"
import style0 from "./access-denied.view.vue?vue&type=style&index=0&id=2d56f062&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56f062",
  null
  
)

export default component.exports